module.exports = __webpack_public_path__ + "static/media/mojave-purple.59375b82.jpg";